import { FC } from 'react';
import { Box, TextField, Typography, Autocomplete } from '@mui/material';
import { IHsCodeItem } from 'redux/reducers/hscodes/types';
import { SearchByNameFieldProps } from './types';

export const SearchByNameField: FC<SearchByNameFieldProps> = ({
	label,
	hsCodeInput,
	hsCodeValue,
	hsCodeOptions,
	hsCodeLoading,
	onInputChange,
	onValueChange,
}) => {
	return (
		<Autocomplete<IHsCodeItem>
			size="small"
			options={hsCodeOptions}
			loading={hsCodeLoading}
			value={hsCodeValue}
			inputValue={hsCodeInput}
			onInputChange={(event, newInputValue) => {
				onInputChange(newInputValue);
			}}
			onChange={(event, newValue) => {
				onValueChange(newValue);
			}}
			getOptionLabel={(option) => option.description}
			renderOption={(props, option) => (
				<Box component="li" {...props}>
					<Typography variant="body2" sx={{ fontWeight: 'bold' }}>
						{option.code}
					</Typography>
					<Typography variant="body2" sx={{ ml: 1, color: 'text.secondary' }}>
						{option.description}
					</Typography>
				</Box>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					label={`${label} (Search by name)`}
					placeholder="Enter product name"
					variant="outlined"
				/>
			)}
			noOptionsText={hsCodeInput.length > 2 ? 'No options' : 'Enter at least 2 characters'}
			loadingText="Loading..."
		/>
	);
};
